module.exports = __webpack_public_path__ + "img/icb-empty-Adv-e@3x.fa577997.png";